import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuthContext";
import axiosInstance from "../../hooks/axiosInstance";

export default function DashboardPage() {
  const [analytic, setAnalytic] = useState(null);
  const [productCustom, setAproductCustom] = useState(null);
  const [invoiceAnalytic, setInvoiceAnalytic] = useState(null);
  const { userData } = useAuth();

  useEffect(() => {
    const fetchAnalytic = async () => {
      try {
        const response = await axiosInstance.get(
          "/user/dashboard/fixed_renewal_product_account_analytics"
        );

        setAnalytic(response.data.data);
      } catch (error) {
        console.error("Error fetching analytic:", error);
      }
    };

    fetchAnalytic();
  }, []);

  useEffect(() => {
    const fetchProductCustom = async () => {
      try {
        const response = await axiosInstance.get(
          "/user/dashboard/product_and_custom"
        );

        setAproductCustom(response.data.data);
      } catch (error) {
        console.error("Error fetching product analytic:", error);
      }
    };

    fetchProductCustom();
  }, []);

  useEffect(() => {
    const fetchInvoiceAnalytic = async () => {
      try {
        const response = await axiosInstance.get(
          "/user/dashboard/invoice_analytics"
        );

        setInvoiceAnalytic(response.data.data);
      } catch (error) {
        console.error("Error fetching analytic:", error);
      }
    };

    fetchInvoiceAnalytic();
  }, []);

  const formatAmount = (amount) => {
    return new Intl.NumberFormat().format(amount);
  };

  // Check if userData and its properties exist
  if (!userData || !userData.userInfo || !userData.userInfo.user) {
    return <div>Loading...</div>;
  }

  const user = userData.userInfo.user;

  return (
    <>
      <div className="row">
        <div className="col">
          <div className="h-100">
            <div className="row mb-3 pb-1">
              <div className="col-12">
                <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                  <div className="flex-grow-1">
                    <h4 className="fs-16 mb-1">
                      Welcome back,{" "}
                      <span className="text-info font-weight-bold">
                        {user?.last_name}
                      </span>
                    </h4>
                    <p className="text-muted mb-0">
                      Here’s what’s happening within Action Aid today.
                    </p>
                  </div>
                </div>
                {/* <!-- end card header --> */}
              </div>
              {/* <!--end col--> */}
            </div>
            {/* <!--end row--> */}

            <div className="row">
              <div className="col-xl-12">
                <div className="card crm-widget">
                  <div className="card-body p-0">
                    <div className="row row-cols-xxl-5 row-cols-md-3 row-cols-1 g-0">
                      <div className="col">
                        <div className="py-4 px-3">
                          <h5 className="text-muted text-uppercase fs-13">
                            TOTAL ACCOUNTS{" "}
                            <i className="ri-arrow-up-circle-line text-success fs-18 float-end align-middle"></i>
                          </h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <i className="ri-group-line display-6 text-muted"></i>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0">
                                <span className="counter-value" data-target="5">
                                  {analytic && analytic.count_account}
                                </span>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <!-- end col --> */}
                      <div className="col">
                        <div className="mt-3 mt-md-0 py-4 px-3">
                          <h5 className="text-muted text-uppercase fs-13">
                            TOTAL PRODUCTS{" "}
                            <i className="ri-arrow-up-circle-line text-warning fs-18 float-end align-middle"></i>
                          </h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              {/* <i className="ri-exchange-dollar-line display-6 text-muted"></i> */}
                              <i class="bi bi-box-seam display-6 text-muted"></i>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0">
                                <span className="counter-value" data-target="8">
                                  {analytic && analytic?.count_product}
                                </span>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <!-- end col --> */}
                      <div className="col">
                        <div className="mt-3 mt-md-0 py-4 px-3">
                          <h5 className="text-muted text-uppercase fs-13">
                            TOTAL CUSTOM PRODUCTS{" "}
                            <i className="ri-arrow-down-circle-line text-warning fs-18 float-end align-middle"></i>
                          </h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <i className="ri-shopping-bag-2-line display-6 text-muted"></i>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0">
                                <span className="counter-value" data-target="7">
                                  {analytic && analytic.count_custom_product}
                                </span>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <!-- end col --> */}
                      <div className="col">
                        <div className="mt-3 mt-lg-0 py-4 px-3">
                          <h5 className="text-muted text-uppercase fs-13">
                            PAID RENEWAL{" "}
                            <i className="ri-arrow-down-circle-line text-danger fs-18 float-end align-middle"></i>
                          </h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <i className="ri-wallet-3-line text-success display-6"></i>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0">
                                <span
                                  className="counter-value"
                                  data-target="1050"
                                >
                                  {analytic && analytic.total_paid}
                                </span>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <!-- end col --> */}
                      {/* <!-- end col --> */}
                      <div className="col">
                        <div className="mt-3 mt-lg-0 py-4 px-3">
                          <h5 className="text-muted text-uppercase fs-13">
                            UNPAID RENEWAL{" "}
                            <i className="ri-arrow-up-circle-line text-success fs-18 float-end align-middle"></i>
                          </h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <i className="ri-wallet-3-line text-warning display-6"></i>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0">
                                <span
                                  className="counter-value"
                                  data-target="15"
                                >
                                  {analytic && analytic.total_unpaid}
                                </span>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="mt-3 mt-lg-0 py-4 px-3">
                          <h5 className="text-muted text-uppercase fs-13">
                            PARTLY_PAID RENEWAL{" "}
                            <i className="ri-arrow-up-circle-line text-success fs-18 float-end align-middle"></i>
                          </h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <i className="ri-wallet-3-line text-alternate display-6 text-muted"></i>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0">
                                <span
                                  className="counter-value"
                                  data-target="15"
                                >
                                  {analytic && analytic.total_partly_paid}
                                </span>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col">
                        <div className="mt-3 mt-lg-0 py-4 px-3">
                          <h5 className="text-muted text-uppercase fs-13">
                            UNPAID RENEWAL{" "}
                            <i className="ri-arrow-up-circle-line text-success fs-18 float-end align-middle"></i>
                          </h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <i className="ri-trophy-line display-6 text-muted"></i>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0">
                                <span
                                  className="counter-value"
                                  data-target="15"
                                >
                                  {analytic && analytic.total_unpaid}
                                </span>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      {/* <!-- end col --> */}
                      <div className="col">
                        <div className="mt-3 mt-lg-0 py-4 px-3">
                          <h5 className="text-muted text-uppercase fs-13">
                            DUE RENEWAL{" "}
                            <i className="ri-arrow-down-circle-line text-danger fs-18 float-end align-middle"></i>
                          </h5>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <i className="ri-wallet-3-line text-danger display-6"></i>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h2 className="mb-0">
                                <span
                                  className="counter-value"
                                  data-target="1050"
                                >
                                  {analytic && analytic.total_due}
                                </span>
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <!-- end col --> */}
                    </div>{" "}
                    {/* <!-- end row --> */}
                  </div>
                  {/* <!-- end card body --> */}
                </div>
                {/* <!-- end card --> */}
              </div>
              {/* <!-- end col --> */}
            </div>
            {/* <!-- end row--> */}

            <div className="row">
              <div className="col-xxl-12">
                <div className="row">
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-header border-0">
                        <h4 className="card-title mb-0">Latest Products.</h4>
                      </div>
                      {/* <!-- end cardheader --> */}
                      {productCustom &&
                      productCustom.latest_products.length > 0 ? (
                        productCustom.latest_products.map((product, index) => (
                          <div className="card-body pt-0" key={index}>
                            <div className="mini-stats-wid d-flex align-items-center mt-3">
                              <div className="flex-shrink-0 avatar-sm">
                                <span className="mini-stat-icon avatar-title rounded-circle text-success bg-success-subtle fs-4">
                                  {index + 1}
                                </span>
                              </div>
                              <div className="flex-grow-1 ms-3">
                                <h6 className="mb-1">{product.product_name}</h6>
                                <p className="text-muted mb-1">
                                  <strong>Category:</strong>{" "}
                                  {product.category.name || "N/A"}
                                </p>
                                <p className="text-muted mb-1">
                                  <strong>Subcategory:</strong>{" "}
                                  {product.sub_category.name || "N/A"}
                                </p>
                                <p className="text-muted mb-1">
                                  <strong>Price:</strong>{" "}
                                  {formatAmount(product.amount) || "N/A"}
                                </p>
                                <p className="text-muted mb-0">
                                  <strong>Date:</strong>{" "}
                                  {product.created_at
                                    ? new Date(
                                        product.created_at
                                      ).toLocaleDateString("en-US", {
                                        month: "short",
                                        day: "2-digit",
                                        year: "numeric",
                                      })
                                    : "N/A"}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="card-body pt-0">
                          <p className="text-muted">No products available.</p>
                        </div>
                      )}

                      {/* <!-- end cardbody --> */}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-header border-0">
                        <h4 className="card-title mb-0">
                          Latest Custom Products.
                        </h4>
                      </div>
                      {/* <!-- end cardheader --> */}
                      {productCustom &&
                      productCustom.latest_custom_products.length > 0 ? (
                        productCustom.latest_custom_products.map(
                          (product, index) => (
                            <div className="card-body pt-0" key={index}>
                              <div className="mini-stats-wid d-flex align-items-center mt-3">
                                <div className="flex-shrink-0 avatar-sm">
                                  <span className="mini-stat-icon avatar-title rounded-circle text-success bg-success-subtle fs-4">
                                    {index + 1}
                                  </span>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                  <h6 className="mb-1">
                                    {product.product_name}
                                  </h6>
                                  <p className="text-muted mb-1">
                                    <strong>Price:</strong>{" "}
                                    {/* {formatAmount(product.amount) || "N/A"} */}
                                    Custom
                                  </p>
                                  <p className="text-muted mb-0">
                                    <strong>Date:</strong>{" "}
                                    {product.created_at
                                      ? new Date(
                                          product.created_at
                                        ).toLocaleDateString("en-US", {
                                          month: "short",
                                          day: "2-digit",
                                          year: "numeric",
                                        })
                                      : "N/A"}
                                  </p>
                                </div>
                              </div>
                            </div>
                          )
                        )
                      ) : (
                        <div className="card-body pt-0">
                          <p className="text-muted">
                            No custom products available.
                          </p>
                        </div>
                      )}

                      {/* <!-- end cardbody --> */}
                    </div>
                  </div>
                </div>
                {/* <!-- end card --> */}
              </div>
            </div>

            <div className="row">
              <div className="col-xl-4">
                <div className="card card-height-100">
                  <div className="card-header align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">Invoices</h4>
                  </div>
                  {/* <!-- end card header --> */}

                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table table-centered table-hover align-middle table-nowrap mb-0">
                        <thead>
                          <tr>
                            <th style={{ fontSize: "5px" }}></th>
                            <th style={{ fontSize: "10px" }}>Total Paid</th>
                            <th style={{ fontSize: "10px" }}>Total Amount</th>
                            <th style={{ fontSize: "10px" }}>Balance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {invoiceAnalytic &&
                          invoiceAnalytic.latest_invoice_custom.length > 0 ? (
                            invoiceAnalytic.latest_invoice_custom.map(
                              (invoice, index) => (
                                <tr>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <div className="flex-shrink-0 me-2">
                                        <img
                                          src="/assets/images/companies/img-1.png"
                                          alt=""
                                          className="avatar-sm p-2"
                                        />
                                      </div>
                                      <div>
                                        <h5 className="fs-14 my-1 fw-medium">
                                          <Link
                                            to="apps-ecommerce-seller-details.html"
                                            className="text-reset"
                                          >
                                            {" "}
                                            {invoice.account_name}
                                          </Link>
                                        </h5>
                                        {/* <span className="text-muted">Oliver Tyler</span> */}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <span className="badge bg-success-subtle text-success">
                                      {invoice.total_paid}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-muted">
                                      {invoice.total_amount}
                                    </span>
                                  </td>
                                  <td>
                                    <h5 className="fs-14 mb-0">
                                      {invoice.total_balance}
                                    </h5>
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <div className="card-body pt-0">
                              <p className="text-muted">
                                No innvoices available.
                              </p>
                            </div>
                          )}
                        </tbody>
                      </table>
                      {/* <!-- end table --> */}
                    </div>
                  </div>
                  {/* <!-- .card-body--> */}
                </div>
                {/* <!-- .card--> */}
              </div>
              <div className="col-xl-8">
                <div className="row">
                  <div className="col-md-6">
                    <div className="card card-height-100">
                      <div className="card-header align-items-center d-flex">
                        <h4 className="card-title mb-0 flex-grow-1">
                          Fixed Renewals
                        </h4>
                      </div>
                      {/* <!-- end card header --> */}

                      <div className="card-body">
                        <div className="table-responsive table-card">
                          <table className="table table-centered table-hover align-middle table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th style={{ fontSize: "5px" }}></th>
                                <th style={{ fontSize: "10px" }}>Total Paid</th>
                                <th style={{ fontSize: "10px" }}>
                                  Total Amount
                                </th>
                                <th style={{ fontSize: "10px" }}>Balance</th>
                              </tr>
                            </thead>
                            <tbody>
                              {invoiceAnalytic &&
                              invoiceAnalytic.latest_invoice.length > 0 ? (
                                invoiceAnalytic.latest_invoice.map(
                                  (invoice, index) => (
                                    <tr>
                                      <td>
                                        <div className="d-flex align-items-center">
                                          <div className="flex-shrink-0 me-2">
                                            <img
                                              src="/assets/images/companies/img-1.png"
                                              alt=""
                                              className="avatar-sm p-2"
                                            />
                                          </div>
                                          <div>
                                            <h5 className="fs-14 my-1 fw-medium">
                                              <Link
                                                to="apps-ecommerce-seller-details.html"
                                                className="text-reset"
                                              >
                                                {" "}
                                                {invoice.account.company_name}
                                              </Link>
                                            </h5>
                                            {/* <span className="text-muted">Oliver Tyler</span> */}
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <span className="badge bg-success-subtle text-success">
                                          {invoice.amount}
                                        </span>
                                      </td>
                                      <td>
                                        <span className="text-muted">
                                          {invoice.amount_paid}
                                        </span>
                                      </td>
                                      <td>
                                        <h5 className="fs-14 mb-0">
                                          {invoice.balance}
                                        </h5>
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <div className="card-body pt-0">
                                  <p className="text-muted">
                                    No fix renewals available.
                                  </p>
                                </div>
                              )}
                            </tbody>
                          </table>
                          {/* <!-- end table --> */}
                        </div>
                      </div>
                      {/* <!-- .card-body--> */}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card card-height-100">
                      <div className="card-header align-items-center d-flex">
                        <h4 className="card-title mb-0 flex-grow-1">
                          Custom Renewals
                        </h4>
                      </div>
                      {/* <!-- end card header --> */}

                      <div className="card-body">
                        <div className="table-responsive table-card">
                          <table className="table table-centered table-hover align-middle table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th style={{ fontSize: "5px" }}></th>
                                <th style={{ fontSize: "10px" }}>Total Paid</th>
                                <th style={{ fontSize: "10px" }}>
                                  Total Amount
                                </th>
                                <th style={{ fontSize: "10px" }}>Balance</th>
                              </tr>
                            </thead>
                            <tbody>
                              {invoiceAnalytic &&
                              invoiceAnalytic.latest_custom_invoice.length >
                                0 ? (
                                invoiceAnalytic.latest_custom_invoice.map(
                                  (invoice, index) => (
                                    <tr>
                                      <td>
                                        <div className="d-flex align-items-center">
                                          <div className="flex-shrink-0 me-2">
                                            <img
                                              src="/assets/images/companies/img-1.png"
                                              alt=""
                                              className="avatar-sm p-2"
                                            />
                                          </div>
                                          <div>
                                            <h5 className="fs-14 my-1 fw-medium">
                                              <Link
                                                to="apps-ecommerce-seller-details.html"
                                                className="text-reset"
                                              >
                                                {" "}
                                                {invoice.account.company_name}
                                              </Link>
                                            </h5>
                                            {/* <span className="text-muted">Oliver Tyler</span> */}
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <span className="badge bg-success-subtle text-success">
                                          {invoice.amount}
                                        </span>
                                      </td>
                                      <td>
                                        <span className="text-muted">
                                          {invoice.amount_paid}
                                        </span>
                                      </td>
                                      <td>
                                        <h5 className="fs-14 mb-0">
                                          {invoice.balance}
                                        </h5>
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <div className="card-body pt-0">
                                  <p className="text-muted">
                                    No custom renewals available.
                                  </p>
                                </div>
                              )}
                            </tbody>
                          </table>
                          {/* <!-- end table --> */}
                        </div>

                        {/* <div className="align-items-center mt-4 pt-2 justify-content-between row text-center text-sm-start">
                      <div className="col-sm">
                        <div className="text-muted">
                          Showing <span className="fw-semibold">5</span> of{" "}
                          <span className="fw-semibold">25</span> Results
                        </div>
                      </div>
                      <div className="col-sm-auto  mt-3 mt-sm-0">
                        <ul className="pagination pagination-separated pagination-sm mb-0 justify-content-center">
                          <li className="page-item disabled">
                            <Link to="#" className="page-link">
                              ←
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link to="#" className="page-link">
                              1
                            </Link>
                          </li>
                          <li className="page-item active">
                            <Link to="#" className="page-link">
                              2
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link to="#" className="page-link">
                              3
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link to="#" className="page-link">
                              →
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div> */}
                      </div>
                      {/* <!-- .card-body--> */}
                    </div>
                  </div>
                </div>
                {/* <!-- .card--> */}
              </div>
              {/* <!-- .col--> */}
            </div>
            {/* <!-- end row--> */}
          </div>
          {/* <!-- end .h-100--> */}
        </div>
        {/* <!-- end col --> */}
      </div>
    </>
  );
}
